'use client'

import { useEffect } from 'react'
import { useUser } from '@clerk/nextjs'

/**
 * Component that synchronizes Clerk user data to our database
 * This component is meant to be included in the app layout to ensure
 * user data is synced whenever a signed-in user visits any page
 */
export default function AuthSync() {
  const { user, isSignedIn, isLoaded } = useUser()

  // Sync user data when the user is loaded and signed in
  useEffect(() => {
    async function syncUserToDB() {
      if (isLoaded && isSignedIn && user) {
        try {
          // Call our API endpoint to sync user data
          const response = await fetch('/api/auth/sync', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            }
          })

          if (!response.ok) {
            console.error(`Failed to sync user data: ${response.status} ${response.statusText}`)
          }
        } catch (error) {
          console.error('Error syncing user data:', error)
        }
      }
    }

    syncUserToDB()
  }, [isLoaded, isSignedIn, user])

  // This component doesn't render anything visible
  return null
} 